"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMAGE_TIMEOUT_DURATION_MS = void 0;
exports.IMAGE_TIMEOUT_DURATION_MS = 7000;
//# sourceMappingURL=playerConstants.js.map